export const isEmail = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ?
  'Adresse email invalide' : undefined

const isMobile = value =>
  value && /^([+]?[1-9][0-9]{1,2}|0)[6-7][0-9]{8}$/.test(value)

export const validatePhone = value =>
  (value === '') || isMobile(value) ? undefined : 'Numéro de portable invalide'